module.exports = __webpack_public_path__ + "diners-club.png";